module.exports = __webpack_public_path__ + "img/src/assets/img_new/companies/fin-trans.png";